$.nette.ext('reInit', {
    start: function() {
        hideAllTooltips();
        closeAllFlashMessages();
    },
    complete: function() {
        initEventsWithReload();
    }
});
